// Copyright (c) 2017 Deere & Company

import * as helpers from './helpers';
import React, {
    PropTypes,
    PureComponent
} from 'react';
import Accordion from '../../accordion';
import {Checkbox} from 'cap-it-ui.toggles';
import DealerHierarchyAccounts from './dealer-hierarchy-accounts';

class DealerHierarchyCities extends PureComponent {

    handleAccountChange = selectedCity => accountChanges => {

        this.props.onAccountChange({
            ...accountChanges,
            selectedCity
        });

    };

    handleCityChange = city => () => {

        const selectedCity = city.id;
        const selectedCities = helpers.updateSelectionMap(this.props.selectedCities, selectedCity);
        const citiesToCheck = helpers.getHashesToCheck(this.props.cities, 'id');

        this.props.onCityChange({
            citiesToCheck,
            city,
            selectedCities,
            selectedCity
        });

    };

    render() {

        return (
            <ul className='cities'>
                {this.props.cities.map((city, cityIndex) =>
                    <li key={cityIndex}>
                        <Accordion
                            accordionId={`${city.id}-${cityIndex}`}
                            body={
                                <DealerHierarchyAccounts
                                    accounts={city.accounts}
                                    onAccountChange={this.handleAccountChange(city.id)}
                                    selectedAccounts={this.props.selectedAccounts}
                                />
                            }
                            title={
                                <Checkbox
                                    id={`${city.id}-${cityIndex}`}
                                    onChange={this.handleCityChange(city)}
                                    selected={this.props.selectedCities[city.id]}
                                >
                                    {city.city}
                                </Checkbox>
                            }
                        />
                    </li>
                )}
            </ul>

        );

    }

}

DealerHierarchyCities.displayName = 'DealerHierarchyCities';
DealerHierarchyCities.propTypes = {
    cities: PropTypes.array.isRequired,
    onAccountChange: PropTypes.func.isRequired,
    onCityChange: PropTypes.func.isRequired,
    selectedAccounts: PropTypes.object.isRequired,
    selectedCities: PropTypes.object.isRequired
};

export default DealerHierarchyCities;



// WEBPACK FOOTER //
// ./src/shared/components/facets/dealer-hierarchy/dealer-hierarchy-cities.js